import { ChangeDetectorRef, Pipe, PipeTransform } from '@angular/core';
import { Contact } from 'common/store/genesys-cloud/external-contacts/models/contact.model';
import { TranslateService } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

@Pipe({
  name: 'gcContactDisplayName',
  // We need impure pipe because AsyncPipe is impure too
  // eslint-disable-next-line @angular-eslint/no-pipe-impure
  pure: false
})
export class GenesysContactDisplayNamePipe extends AsyncPipe implements PipeTransform {
  private _unknownCustomerName$ = this._translateService.get('gcContactDisplayName.unknownCustomer');

  constructor(changeDetectorRef: ChangeDetectorRef, private _translateService: TranslateService) {
    super(changeDetectorRef);
  }

  transform(contact?: any): any {
    return this._getDisplayName(contact) ||
      super.transform(this._unknownCustomerName$);
  }

  private _getDisplayName(contact: Contact): string {
    return [contact?.firstName, contact?.middleName, contact?.lastName]
      .filter(Boolean)
      .join(' ');
  }
}
